<template>
  <div>
    <div class="row mt-1">
      <b class="mr-2 mt-1">ML Valid: </b>
      <div v-if="isLoading">
        <div
          v-b-tooltip.hover
          class="loading btn btn-secondary"
          placement="bottom"
          title="Nicht validiert"
        >
          <i class="fas fa-spinner" />
        </div>
      </div>
      <div v-if="!isLoading && validationObject.validationStatus == 'NotValidated'">
        <div
          v-b-tooltip.hover
          class="validationNotRan"
          placement="bottom"
          title="Nicht validiert"
        >
          <i class="fas fa-exclamation" />
        </div>
      </div>
      <div v-if="!isLoading && validationObject.validationStatus == 'Success'">
        <div
          v-b-tooltip.hover
          :title="'Zuletzt validiert: ' + formatDate(validationObject.lastValidated)"
          class="validationSuccess"
          placement="bottom"
        >
          <i class="fas fa-check" />
        </div>
      </div>
      <div v-if="!isLoading && validationObject.validationStatus == 'Error'">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              v-b-modal="'errors' + validationObject.id"
              class="validationFailed"
              placement="bottom"
              v-bind="attrs"
              v-on="on"
            >
              <i class="fas fa-times" />
            </div>
          </template>
          <span>
            {{ "Zuletzt validiert: " + formatDate(validationObject.lastValidated) }}
          </span>
        </v-tooltip>
      </div>
      <button
        v-if="!disableValidation"
        v-b-tooltip.hover
        :disabled="isLoading"
        class="btn btn-success mb-2 ml-1 smallActionButton"
        placement="bottom"
        title="Validierungen überprüfen"
        type="button"
        @click="checkAllValidations"
      >
        <i class="fas fa-play" />
      </button>
    </div>
  </div>
</template>

<script>
import { GetValidations, RunValidation } from "@/services/minimum.wage.services/validation.minimum.wages.js";
import { GetConfigurations } from "@/services/minimum.wage.services/configuration.minimum.wages.js";

export default {
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
    disableValidation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      remainingLoadings: 0,
      allConfigutations: [],
      allValidations: [],
      remainingValidations: 0,
    };
  },
  computed: {
    validationObject() {
      if (!this.allValidations || this.allValidations.length === 0) {
        return {
          lastValidated: null,
          validationStatus: "NotValidated",
          id: null,
        };
      }

      var hasCompletedValidations = this.allValidations.some((validation) => {
        return validation.lastValidated !== null;
      });

      if (!hasCompletedValidations) {
        return {
          lastValidated: null,
          validationStatus: "NotValidated",
          id: null,
        };
      }

      var validationsWithError = this.allValidations.filter((validation) => {
        return validation.lastValidated && !validation.lastValidationSuccesful;
      });

      if (validationsWithError && validationsWithError.length > 0) {
        var latestError = validationsWithError.length === 1 ? validationsWithError[0] : validationsWithError.reduce((latest, current) => {
          return new Date(latest.lastValidated) > new Date(current.lastValidated) ? latest : current;
        });

        return {
          lastValidated: latestError.lastValidated,
          validationStatus: "Error",
          id: latestError.id,
        };
      }

      var latestSuccess = this.allValidations.length === 1 ? this.allValidations[0] : this.allValidations.reduce((latest, current) => {
        return new Date(latest.lastValidated) > new Date(current.lastValidated) ? latest : current;
      });

      return {
        lastValidated: latestSuccess.lastValidated,
        validationStatus: "Success",
        id: latestSuccess.id,
      };
    },
  },
  created() {
    this.initializeValidation();
  },
  methods: {
    initializeValidation() {
      // Add initialization logic here
      this.getAllConfigurations();
    },
    formatDate(date) {
      var newDate = this.$moment(date).format("DD.MM.YYYY HH:mm");
      return newDate;
    },
    getAllConfigurations() {
      this.isLoading = true;
      this.configurations = [];

      GetConfigurations(
        this.contractId,
        this.versionId,
        this.editionId,
        (result) => {
          this.allConfigutations = result;
          this.getValidations();
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
        },
      );
    },
    getValidations() {
      this.errorObject = null;
      this.allValidations = [];

      this.remainingLoadings = this.allConfigutations.length;

      this.allConfigutations.map((configuration) => {
        GetValidations(
          this.contractId,
          this.versionId,
          configuration.id,
          (response) => {
            this.allValidations = [...this.allValidations, ...response];
            this.remainingLoadings--;
            if (this.remainingLoadings <= 0) {
              this.isLoading = false;
            }
          },
          (error) => {
            this.errorObject = error;
            this.remainingLoadings--;
            if (this.remainingLoadings <= 0) {
              this.isLoading = false;
            }
          },
        );
      });
    },
    checkAllValidations() {
      this.isLoading = true;
      this.remainingValidations = this.allValidations.length;

      this.allValidations.map((validation) => {
        RunValidation(
          this.contractId,
          this.versionId,
          this.editionId,
          validation.id,
          () => {
            this.remainingValidations--;
            if (this.remainingValidations <= 0) {
              this.getValidations();
            }
          },
          () => {
            this.remainingValidations--;
            if (this.remainingValidations <= 0) {
              this.getValidations();
            }
          },
        );
      });
    },
  },
};
</script>
<style scoped>
.loading {
  width: 25px;
  height: 25px;
  padding-left: 4px;
  padding-top: 2px;
  font-size: 16px;
  border-radius: 30px;
}

.validationSuccess {
  background-color: #219600;
  width: 25px;
  color: white;
  height: 25px;
  padding-left: 4px;
  padding-top: 2px;
  font-size: 16px;
  border-radius: 30px;
}

.validationNotRan {
  background-color: #ffd900;
  width: 25px;
  color: black;
  height: 25px;
  padding-left: 10px;
  padding-top: 2px;
  font-size: 16px;
  border-radius: 30px;
}

.validationFailed {
  background-color: #ff0000;
  width: 25px;
  color: white;
  height: 25px;
  padding-left: 6px;
  padding-top: 0px;
  font-size: 18px;
  border-radius: 30px;
}
</style>
